<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h4 class="title">账号信息</h4>
        </template>

        <wizard-tab :before-change="() => validateStep('step1', 1)">
          <template slot="label"> 帐号 </template>
          <user-base-info
            :user="user"
            ref="step1"
            @setlogImg="setlogImg"
            @on-validated="onStepValidated"
          ></user-base-info>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2', 1)">
          <template slot="label"> 个人信息 </template>
          <user-ext-info :user="user" ref="step2" @on-validated="onStepValidated"></user-ext-info>
        </wizard-tab>

        <!-- <wizard-tab :before-change="() => validateStep('step3', 0)">
          <template slot="label"> 设置 </template>
          <user-access-info :user="user" ref="step3" @prgroupIdovince="prgroupIdovince" @on-validated="wizardComplete"></user-access-info>
        </wizard-tab> -->
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import kit from '/common/js/kit.js';
import UserBaseInfo from '@/pages/Dashboard/Account/UserBaseInfo.vue';
import UserExtInfo from '@/pages/Dashboard/Account/UserExtInfo.vue';
import UserAccessInfo from '@/pages/Dashboard/Account/UserAccessInfo.vue';
import { SimpleWizard, WizardTab } from '@/components';
import { userInfo, userUpdate } from '@/api/user';
export default {
  data() {
    return {
      uid: '',
      wizardModel: {},
      user: Object,
    };
  },
  components: {
    UserBaseInfo,
    UserExtInfo,
    UserAccessInfo,
    SimpleWizard,
    WizardTab,
  },
  created() {
    this.uid = this.$route.query.uid || '';
    this.userInfo();
  },
  methods: {
    // 群组未复制
    prgroupIdovince(data) {
      // this.user.user.email = validated.userData.email
    },
    setlogImg(url) {
      this.user.user.avatar = url;
    },
    userInfo() {
      let that = this;
      let tempData = {
        uid: that.uid,
      };
      userInfo(tempData).then(res => {
        if (res.code == '200') {
          res.data.password = res.data.is_set_password ? '*******' : '';
          that.user = { ...that.user, ...res.data };
          if (that.uid) return;
          kit.setUserInfo(that.user);
        }
      });
    },
    validateStep(ref, type) {
      return this.$refs[ref].validate();
      // let data = await this.wizardComplete(type);
      // return data.data.code === '200';
    },
    onStepValidated(validated, model) {
      if (validated.step == 'step1') {
        let { username, password, email, phone } = validated.userData;
        this.user.user.accountNumber = username;
        // this.user.user.password =password
        this.user.user.email = email;
        this.user.user.phoneNumber = phone;
      } else if (validated.step == 'step2') {
        let { name, sex, job_title, province, city, region, detail_address } = validated.userData;
        this.user.user.nickName = name; //姓名
        this.user.user.sex = sex; //性别
        this.user.user.academicTitle = job_title; //职称
        let addressArr = [province, city, region];
        this.user.user.addressList = addressArr; //province       city  region
        this.user.user.addressDetail = detail_address; //详细地址
        // detail_address
        // this.user.user.professionId = validated.userData.professionId   //职业
        // this.user.user.nickName = validated.userData.unit      //单位
        // this.user.user.nickName = validated.userData.secondary_unit      //二级单位
        this.wizardComplete();
      } else if (validated.step == 'step3') {
      }

      this.wizardModel = { ...this.wizardModel, ...model };
      // this.wizardComplete('edit');
    },
    wizardComplete() {
      this.user.address = [this.user.province, this.user.city, this.user.region];
      return this.userUpdate();
    },
    userUpdate() {
      let that = this;
      return userUpdate(that.user).then(res => {
        if (res.code == '200') {
          this.$store.commit('permission/SET_USER', that.user.user);
          this.$notify({
            timeout: 1500,
            message: '用户信息设置成功！',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
          this.$router.push('/dashboard');
          if (that.uid) {
            that.$router.push({ name: 'UserAdmin' });
          }
          that.userInfo();
        }
        return res;
      });
    },
  },
};
</script>
